module.exports = __webpack_public_path__ + "img/gravier_roule_caramel.cbea16f5.jpg";